import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import renderHTML from 'react-render-html';
import gsap from 'gsap';
import _ from 'lodash';
import config from "../../../config/config_data";

import ThumbsUp from './../../../icons/thumb_up.svg';
import DownArrow from './../../../icons/down_arrow.svg';
import UpArrow from './../../../icons/up_arrow.svg';
import VideoPlayer from '../../VideoPlayer';
import Alert from './Alert/Alert';
import Scorecard from './Scorecard/Scorecard';
import ModalPopUp from "../../ui/PopUp/ModalPopUp";
import './VideoConversation.sass';
import ScorecardModel from './Scorecard/ScorecardModel';
import apiJSON from "../../../api/apiJSON";
import PieGraph from "../../ui/PieGraph/PieGraph";


const VideoConversation = ({data, completed, next}) => {
    const [choiceCounter, setChoiceCounter] = useState(0);
    const [alert, setAlert] = useState(false);
    const [feedback, setFeedback] = useState(false);
    const [lastChoice, setLastChoice] = useState(false);
    const [lastIndex, setLastIndex] = useState(false);
    const [showScorecard, setShowScorecard] = useState(false);
    const [showScorecardPreview, setShowScorecardPreview] = useState(false);
    const [showDropDown, setShowDropDown] = useState(false)
    const [resetChoice, setResetChoice] = useState(false);
    const debug = config.debug;

    // load activity json file
    const jsonData = apiJSON.get(data)
    const {scenarios} = jsonData;
    const scenario = scenarios[0];
    const {scorecard, alerts, scorecardThreshold} = scenario;
    const [score, setScore] = useState(scorecard);
    const [scorecardModel, setScorecardModel] = useState(null);

    useEffect(() => {
        console.log("useEffect, init")
        console.log("debug:" + debug)
        setScorecardModel(new ScorecardModel(scorecard));
    }, []);

    const finished = () => {
        console.log("VideoConversation finished()");
        setChoiceCounter(-1);
        setAlert(false);
        setShowScorecard(true);
        if (scorecardModel.passed()) {
            console.log("completed!!")
            completed();
        }
    };

    useEffect(() => {
        console.log("useEffect, choice made")
        gsap.set('.choices-video,.main-video', {display: 'block'});
        gsap.set('.choices-video,.main-video', {clearProps: 'x'});
        gsap.from('.main-video', {x: -1600});
        gsap.from('.choices-video', {x: 1600});
    }, [choiceCounter, alert]);


    const goTo = (choice) => {
        const {choiceSet} = scenario;
        const {linkage} = choice;
        const alertId = choice.alert;
        setResetChoice(false);
        if (linkage === 'showAlert') {
            // use alert
            const alertData = _.find(alerts, {id: alertId});
            setAlert(alertData);
        } else {
            const index = _.findIndex(choiceSet, (choice) => choice.id === linkage);
            setLastIndex(index);
            setChoiceCounter(index);
        }
    };

    const continueTo = (linkage) => {
        const {choiceSet} = scenario;
        switch (linkage){
            case 'resetChoiceSet':
                setResetChoice(true);
                setChoiceCounter(lastIndex);
                setAlert(false);
                break;
            case 'endScenario':
                finished();
                break;
            default:
                const index = _.findIndex(choiceSet, (choice) => choice.id === linkage);
                setChoiceCounter(index);
                setAlert(false);
        }
    };

    const handleSelect = (choice) => {
        // save last choice
        setLastChoice(choice);
        // if feedback object present, set showFeedback to true
        let showFeedback = !!choice.feedback;
        if (showFeedback) {
            const {feedback} = choice;
            setFeedback(feedback);
        } else {
            if (choice.linkage === 'endScenario') {
                finished();
            } else {
                if (choice.scores) {
                    setScore(handleScores(choice.scores));
                }
                goTo(choice);
            }
        }
    };

    const handleFeedback = () => {
        setFeedback(false);
        if (lastChoice.linkage === 'endScenario') {
            finished();
        } else if (lastChoice.linkage === 'resetChoiceSet') {
            setChoiceCounter(lastIndex);
        } else {
            if (lastChoice.scores) {
                setScore(handleScores(lastChoice.scores));

            }
            goTo(lastChoice);
        }
    };

    const handleScores = (scores) => {
        console.log("handleScores");
        let obj = score;
        scores.forEach((x) => {
            const {field, score} = x;
            obj[field] = obj[field] + score;
            scorecardModel.update(field, score);
        });
        return obj;
    };

    const toggleScorecard = (toggle) => {
        setShowScorecard(toggle);
    };

    const toggleScorecardPreview = () => {
        setShowScorecardPreview(!showScorecardPreview);
    }

    const toggleDropDown = () => {
        setShowDropDown(!showDropDown);
    }

    const handleDropDownSelect = (id) => {
        console.log("dropdown id: " + id)
        if (id === "scorecard") {
            toggleScorecard(true);
        } else {
            var c = {"linkage": id}
            toggleScorecard(false);
            goTo(c);
        }
        toggleDropDown();

    }

    const getPieGraphData = (field) =>{
        console.log("VideoConversation getPieGraphData(",field.id,")");
        if(field.score<=0){
            return  {};
        }
        let pct = Number(field.score/field.min)*100
        var f1 = {
            "id":field.id,
            "color":"#50b748",
            "value": pct
        }
        var f2 = {
            "color":"black",
            "value":100-pct
        }
        return {
            fields:[f1,f2]
        }
    }

    const reset = () => {
        setShowScorecard(false);
        setChoiceCounter(0);
    }

    return (
        <div className="videoConversation"
             style={scenario.bgColor ? {
                 "backgroundColor": scenario.bgColor
             } : {}
             }>
            {scenario &&
                <div className="dropdown-container">
                    <div className="dropdown-button"
                         onClick={toggleDropDown}>
                        {(choiceCounter!==-1)?scenario.choiceSet[choiceCounter].id:"scorecard"}
                        <img src={showDropDown ? UpArrow : DownArrow}
                             style={{width: 20}}/>
                    </div>
                    {showDropDown && (
                        scenario.choiceSet.map((cs, index) => (
                            <div className="dropdown-item"
                                 onClick={() => {
                                     handleDropDownSelect(cs.id)
                                 }}>
                                {cs.id}
                            </div>
                        ))
                    )}
                    {showDropDown &&
                    <div className="dropdown-item"
                         onClick={() => {
                             handleDropDownSelect(("scorecard"))
                         }}>
                        scorecard
                    </div>}
                </div>
            }
            {
                (scorecardModel) && <div className="scoretracker-container">
                    <div className="scoretracker-button"
                         onClick={toggleScorecardPreview}>
                        Scorecard
                        <img src={showScorecardPreview ? UpArrow : DownArrow}
                             style={{width: 20}}/>
                    </div>
                    {
                        showScorecardPreview &&
                        <table className="scoretracker-dropdown">
                            <tr>
                                <th>
                                    Field
                                </th>
                                <th>
                                    Progress
                                </th>
                                <th>
                                    Score
                                </th>
                                <th>
                                    Pass
                                </th>
                            </tr>
                            {
                                scorecardModel.getFields().map((f, index) => (
                                    <tr>
                                        <td>
                                            {f.label}
                                        </td>
                                        <td>
                                            {scorecardModel.passed(f.id)?<img src={ThumbsUp} style={{
                                                width:"25px",
                                                height:"25px"
                                                }}/>:
                                            <PieGraph  id={f.id} width={"25px"} borderColor={"#50b748"} data={getPieGraphData(f)}/>}
                                        </td>
                                        <td>
                                            {f.score}
                                        </td>
                                        <td>
                                            {f.min}
                                        </td>
                                    </tr>
                                ))
                            }
                        </table>
                    }
                </div>
            }

            {feedback && <ModalPopUp data={feedback}
                                     onHide={handleFeedback}/>}
            {(scenario && !alert) && (
                <div className="main-video">
                    {scenario.choiceSet[choiceCounter] && (
                        <VideoPlayer
                            autoplay={true}
                            src={scenario.choiceSet[choiceCounter].video}
                        />
                    )}
                </div>
            )}
            {(scenario && !alert && choiceCounter!==-1) && (
                <div className="choices-video">
                    <ul>
                        {scenario.choiceSet[choiceCounter].choices.map((choice, index) => {
                            return (
                                <li key={index}>
                                    <div className={'choice'}>
                                        <VideoPlayer src={choice.video}/>
                                        <button
                                            className="select-btn"
                                            onClick={() => handleSelect(choice)}
                                        >
                                            SELECT
                                        </button>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}

            {(scenario && !alert) && (
                <div className="instructions">
                    {scenario ? renderHTML(scenario.instructions) : ''}
                </div>
            )}

            {alert && (
                <Alert data={alert}
                       continueTo={continueTo}/>
            )}

            {showScorecard && (
                <Scorecard
                    model={scorecardModel}
                    toggle={toggleScorecard}
                    reset={reset}
                    advance={next}
                />
            )}
        </div>
    );
};

export default VideoConversation;
